import { UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Layout, Menu, Row, Select, Space, Typography } from 'antd';
import { ItemType, MenuItemType } from 'antd/es/menu/interface';
import { memo, Suspense, useEffect, useMemo } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import ModalChangePassword from 'src/components/ModalChangePassword';
import ModalConfirm from 'src/components/ModalConfirm';
import SpinnerLoader from 'src/libraries/SpinnerLoader';
import { RouteMenus } from 'src/routes/menu';
import { Routes } from 'src/routes/route';
import TenantService from 'src/services/tenant.service';
import { useUser } from 'src/stores';
import useTenant from 'src/stores/tenant/tenant.store';
import { ITenant } from 'src/types/tenant.type';
import CONTANTS from 'src/utils/constants';
import EVENT from 'src/utils/event-bus/event';
import FUNCS from 'src/utils/func';
import ChooseTenant from './ChooseTenant';

const svTenant = new TenantService();

function LayoutClient() {
  const { user, clear } = useUser();
  const { tenant, listTenant, changeTenant } = useTenant();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    Array.from(document.getElementsByClassName('ant-menu-submenu-title')).forEach((i) => {
      i.classList.remove('ant-menu-item-selected');
      // @ts-ignore
      const dataSet = i?.dataset?.menuId?.split('-');
      if (dataSet) {
        if (dataSet[dataSet.length - 1] === `/${pathname.split('/')[1]}`) {
          i.classList.add('ant-menu-item-selected');
        }
      }
    });
  }, [pathname]);

  const handleLogout = async () => {
    try {
      // await svAuth.logout();
      clear();

      navigate(Routes.LOGIN.path as string);
    } catch (err) {
      console.log(err);
    }
  };

  const onSelectTenant = async (id: number) => {
    try {
      const newTenant = await svTenant.detail(id);
      changeTenant(newTenant);
    } catch (err) {
      console.log(err);
    }
  };

  const avartarDropdownItems = useMemo<any>(() => {
    return [
      {
        label: <p onClick={EVENT.onShowModalChangePassword}>Đổi mật khẩu</p>,
        key: 'changePassword',
      },
      {
        label: <p onClick={handleLogout}>Đăng xuất</p>,
        key: 'logout',
      },
    ];
  }, []);

  const menus = useMemo<ItemType<MenuItemType>[]>(() => {
    if (!user) return [];

    return RouteMenus.map((i) => ({
      key: i.path,
      label: i.children ? i.title : <div onClick={() => navigate(i.path)}>{i.title}</div>,
      icon: i.icon,
      children: i.children
        ? i.children.map((e) => ({
            key: e.path,
            label: e.children ? e.title : <div onClick={() => navigate(e.path)}>{e.title}</div>,
            icon: i.icon,
            children: e.children
              ? e.children.map((x) => ({
                  key: x.path,
                  label: x.children ? x.title : <div onClick={() => navigate(x.path)}>{x.title}</div>,
                }))
              : undefined,
          }))
        : undefined,
    }));
  }, [user]);

  const { innerHeight: height } = window;

  return (
    <>
      <Layout style={{ minHeight: '100vh' }}>
        <Layout.Header
          // style={{
          //   display: 'flex',
          //   alignItems: 'center',
          //   justifyContent: 'space-between',
          //   backgroundColor: 'white',
          //   borderBottom: '1px solid rgba(5, 5, 5, 0.06)',
          // }}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          <div
            style={{
              display: 'flex',
              margin: '16px 6px',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <img src={FUNCS.getFullUrl(tenant?.logo) || CONTANTS.FALLBACK_IMG} alt="" width="40" />
            <h3 style={{ color: 'white', marginLeft: 8 }}>{tenant?.name || 'Sedu CMS'}</h3>
          </div>

          <Space>
            {tenant && (
              <>
                {tenant.site && (
                  <Link to={tenant.site} target="_blank" rel="noopener noreferrer">
                    <Button type="primary">Xem trang</Button>
                  </Link>
                )}
                <Select
                  value={tenant.id}
                  options={listTenant.map((i) => ({ label: i.name, value: i.id, extend: i }))}
                  onChange={(val) => onSelectTenant(val)}
                  style={{ width: 300 }}
                  optionRender={(option) => {
                    const optTenant = option.data.extend as ITenant;
                    return (
                      <Row>
                        <div style={{ flex: 1 }}>
                          <Row align="middle">
                            <Avatar src={FUNCS.getFullUrl(optTenant.logo)} />

                            <div style={{ flex: 1, marginLeft: 8 }}>
                              <div>{optTenant.name}</div>
                              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                {optTenant.site}
                              </Typography.Text>
                            </div>
                          </Row>
                        </div>
                      </Row>
                    );
                  }}
                />
              </>
            )}
            <div className="icon-wrapper">
              <Dropdown menu={{ items: avartarDropdownItems }} placement="bottomLeft">
                <Avatar size="large" style={{ backgroundColor: 'var(--colorNormal)' }} icon={<UserOutlined />} />
              </Dropdown>
            </div>
          </Space>
        </Layout.Header>

        {tenant ? (
          <Layout>
            <Layout.Sider
              theme="dark"
              collapsible
              // collapsed={collapsed}
              // onCollapse={(value) => setCollapsed(value)}
              style={{ height: height - 104, overflow: 'scroll' }}
            >
              <Menu
                theme="dark"
                mode="inline"
                // defaultOpenKeys={[pathBack]}
                items={menus}
              />
            </Layout.Sider>
            <Layout.Content
              style={{
                position: 'relative',
                maxHeight: height - 64,
                overflowY: 'scroll',
              }}
            >
              <Suspense fallback={<SpinnerLoader bg={false} />}>
                <Outlet />
              </Suspense>
            </Layout.Content>
          </Layout>
        ) : (
          <Suspense fallback={<SpinnerLoader bg={false} />}>
            <ChooseTenant onSelectTenant={onSelectTenant} />
          </Suspense>
        )}
      </Layout>

      <ModalConfirm />
      {user && <ModalChangePassword />}
    </>
  );
}

export default memo(LayoutClient);
